import {  useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import MenuItem from "../../containers/Header/MenuItems/MenuItem/MenuItem";
import {
  FaTachometerAlt,
  FaShoppingCart,
  FaMoneyBillAlt,
  FaUsers,
  FaChartBar,
  FaChartPie,
  FaBell,
  FaQuestionCircle,
  FaCog,
  FaUserCircle,
  FaSignOutAlt,
  FaBox,
  FaList,
  FaImages,
  FaColumns,
  FaBullhorn,
  FaBoxOpen,
  FaAngleRight,
  FaAngleDown,
} from "react-icons/fa";
import "./sidebar.css";
import { jwtDecode } from "jwt-decode";

const SidebarMobile = () => {
  const [open, setOpen] = useState(false);
  const [userRole, setUserRole] = useState("customer");
  const [openSubMenu, setOpenSubMenu] = useState(null); // کنترل زیرمنوها
  const navigate = useNavigate();
  const toggleSubMenu = (menuKey) => {
    setOpenSubMenu(openSubMenu === menuKey ? null : menuKey);
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUserRole(decoded.role);
      } catch (err) {
        console.error("❌ Invalid token:", err);
      }
    }
  }, []);
  const menuItems = [
    {
      to: "/dashboard/profile",
      icon: <FaUserCircle />,
      label: "Profile",
      roles: ["admin", "seller", "customer", "pendingSeller"],
    },
    {
      to: "/dashboard/overview",
      icon: <FaTachometerAlt />,
      label: "Dashboard",
      roles: ["admin"],
      children: [
        {
          to: "/dashboard/overview",
          icon: <FaTachometerAlt />,
          label: "OverView",
          roles: ["admin"],
        },
        {
          to: "/dashboard/reports",
          icon: <FaChartBar />,
          label: "Reports",
          roles: ["admin"],
        },
        {
          to: "/dashboard/statistic",
          icon: <FaChartPie />,
          label: "Statistic",
          roles: ["admin"],
        },
      ],
    },
    {
      label: "Catalog",
      icon: <FaBoxOpen />,
      roles: ["admin", "seller"],
      children: [
        {
          to: "/dashboard/product",
          icon: <FaBox />,
          label: "Product",
          roles: ["admin", "seller"],
        },
        {
          to: "/dashboard/category",
          icon: <FaList />,
          label: "Category",
          roles: ["admin"],
        },
      ],
    },
    {
      label: "Oreders & Peyment",
      icon: <FaShoppingCart />,
      roles: ["admin", "seller", "customer"],
      children: [
        {
          to: "/dashboard/orders",
          icon: <FaShoppingCart />,
          label: "Orders",
          roles: ["admin", "seller", "customer"],
        },
        {
          to: "/dashboard/payments",
          icon: <FaMoneyBillAlt />,
          label: "Payments",
          roles: ["admin"],
        },
      ],
    },
    {
      label: "Site Content",
      icon: <FaBoxOpen />,
      roles: ["admin"],
      children: [
        {
          to: "/dashboard/slider",
          icon: <FaImages />,
          label: "Slider",
          roles: ["admin"],
        },
        {
          to: "/dashboard/campaign",
          icon: <FaBullhorn />,
          label: "Campaign",
          roles: ["admin"],
        },
        {
          to: "/dashboard/footer",
          icon: <FaColumns />,
          label: "Footer",
          roles: ["admin"],
        },
      ],
    },
    {
      to: "/dashboard/settings",
      icon: <FaCog />,
      label: "Settings",
      roles: ["admin", "support"],
      children: [
        {
          to: "/dashboard/users",
          icon: <FaUsers />,
          label: "Users",
          roles: ["admin", "support"],
        },

        {
          to: "/dashboard/general",
          icon: <FaCog />,
          label: "General",
          roles: ["admin"],
        },
      ],
    },

   
  ];

  return (
    <>
      <div className="mobile-header d-lg-none">
        <button className="btn btn-light m-2" onClick={() => setOpen(true)}>
          <FaBars />
        </button>
      </div>

      {open && <div className="backdrop" onClick={() => setOpen(false)} />}

      <div className={`SideDrawerLeft ${open ? "OpenLeft" : "CloseLeft"}`}>
        <nav>
          <ul className="navbar-nav ">
            {menuItems
              .filter((item) => item.roles.includes(userRole))
              .map((item, idx) => (
                <li key={idx} className="nav-item  border-secondary border-bottom py-2">
                  {item.children ? (
                    <>
                      <div
                        className="nav-link d-flex ps-1 justify-content-between align-items-center"
                        onClick={() => toggleSubMenu(item.label)}
                        style={{ cursor: "pointer",width: "200px" }}
                      >
                        <span >
                          {item.icon} {item.label}
                        </span>
                        <span>
                          {openSubMenu === item.label ? (
                            <FaAngleDown />
                          ) : (
                            <FaAngleRight />
                          )}
                        </span>
                      </div>
                      {openSubMenu === item.label && (
                        <ul className="navbar-nav ms-3">
                          {item.children.map((child, cIdx) => (
                            <MenuItem
                              key={cIdx}
                              to={child.to}
                              icon={child.icon}
                            >
                              {child.label}
                            </MenuItem>
                          ))}
                        </ul>
                      )}
                    </>
                  ) : (
                    <div className="me-5">
                    <MenuItem to={item.to} icon={item.icon}>
                      {item.label}
                    </MenuItem>
                    </div>
                  )}
                </li>
              ))}

            <li
              key="logout"
              className="nav-item mt-0"
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="nav-link ms-1 text-danger ms-1">
                <FaSignOutAlt /> Sign Out
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default SidebarMobile;


